import React, {useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import {TextField, FormHelperText, Grid, Button, Typography } from '@material-ui/core';
import {Link} from 'react-router-dom';
import Cookies from 'js-cookie';
import {API} from "aws-amplify";
import CONFIG from "../../../environmentConfig/index";

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: 500,
    backgroundColor: theme.palette.background.primary,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(3, 3, 3),
    color: theme.palette.text.primary,
    [theme.breakpoints.down('xs')]: {
      width: '80%',
    },
  },
  heading: {
    fontSize: '24px',
    lineHeight: '28.13px',
    fontFamily: 'Roboto',
    fontWeight: '400',
    margin: '0 0 10px',
    letterSpacing: '0.11px'
  },
  text: {
    lineHeight: '24px',
    opacity: '0.7',
    letterSpacing: '0.11px'
  },
  input: {
    lineHeight:'24px',
    fontFamily: 'Public Sans',
  },
  submit: {
    marginTop: '24px'
  },
  helpText: {
    fontSize: '14px',
    lineHeight: '24px',
    letterSpacing: '0.11px',
    fontFamily: 'Manrope',
  },
  cancel: {
    padding: '9px 13.5px',
    background: 'transparent',
    color: theme.palette.text.primary,
    fontSize: '14px',
    lineHeight: '21px',
    borderRadius: '0',
    border: '1px solid rgba(255, 255, 255, 0.4)',
    '&:hover': {
      background : '#fff',
      color: '#000'
    }
  },
  enter: {
    border: '1px solid #ED1C24', 
    backgroundColor: '#ED1C24',
    color: theme.palette.text.primary,
    fontSize: '14px',
    lineHeight: '21px',
    borderRadius: '0',
    padding: '9px 13.5px',
    '&:hover' :{
      background: '#FF454C'
    } 
  },
  msgGrid: {
    marginTop: '15px',
    textAlign: 'center'
  },
  msg: {
    marginBottom: '12px',
    color: '#f44336',
    fontWeight: '500',
    marginLeft: theme.spacing(3)
  }
}));

export default function SimpleModal({open, onClose, onSubmit, sessionData}) {
  const classes = useStyles();
  // getModalStyle is not a pure function, we roll the style only on the first render
  const [modalStyle] = React.useState(getModalStyle);
  const [email, setEmail] = useState("");
  const [code, setEventCode] = useState("");
  const [formMsg, setFormMsg] = useState("");
  const [sessionId, setSessionId] = useState("")
  const [isWaiting, setIsWaiting] = useState(false);
  const [isCodeMsg, setIsCodeMsg] = useState(false);
  const [isRegisterMsg, setIsRegisterMsg] = useState(false);
  const [isPasswordMsg, setIsPasswordMsg] = useState(false);


  const validateForm = () => {
    if (email.length === 0) {
      setFormMsg("Please enter an email address.");
      return false;
    }
    if(email.length >= 1){
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)){
      return (true)
      }
      else{
        setFormMsg("Please enter an valid email address.");
        return false
      }
    }
    

    if (code.length === 0) {
      setFormMsg("Please enter event code.");
      return false;
    }
    return true;
  };

  const authenticate = async (sessionId, code, email) => {
    const apiName = CONFIG.API_NAME; // replace this with your api name.
    const path = '/verify-code'; //replace this with the path you have configured on your API
    const myInit = {
      body: {
        sessionId,
        code,
        email,
      },
    };
    return API.post(apiName, path, myInit)
        .then(response => {
          return response
        })
        .catch(error => {
          console.log(error.response);
        });
  }

  const handleClose = () => {
      onClose();
  };

  const handleSubmit = async (event) => {
    
    event.preventDefault();

    setIsCodeMsg(false);
    setIsRegisterMsg(false);
    setIsPasswordMsg(false);

    if (validateForm()) {
      setIsWaiting(true);
      setFormMsg("Authenticating ...");
      try {
        authenticate(sessionData.id, code, email).then(data=>{
          if(data.status){
            let d = new Date();
            d.setTime(d.getTime() + (24*60*60*1000));
            if(Cookies.get('sessionAuth')){
              let cookieData = JSON.parse(Cookies.get('sessionAuth'));
              cookieData.indexOf(sessionData.id)===-1 && Cookies.set('sessionAuth',  JSON.stringify([...cookieData, sessionData.id]), { path: '/', expires: d})
            }else{
              Cookies.set('sessionAuth', JSON.stringify([sessionData.id]), { path: '/', expires: d})
            }
            setFormMsg("Authenticating ... Success.");
            setIsWaiting(false);
            setFormMsg("");
            onSubmit(true)
          }else{
            setFormMsg(data.msg);
          }

        });

        //props.setUser(user);
        //props.userHasAuthenticated(true);
        //history.push("/event");
      } catch (e) {
        setFormMsg("");
        setIsWaiting(false);
        if (e.code === 'UserNotConfirmedException') {
          setIsCodeMsg(true);
        } else if (e.code === 'PasswordResetRequiredException') {
          setIsPasswordMsg(true);
        } else if (e.code === 'NotAuthorizedException') {
          setFormMsg(e.message);
        } else if (e.code === 'UserNotFoundException') {
          setIsRegisterMsg(true);
        } else {
          console.log(e);
          setFormMsg(e.message);
        }
      }
    }
  }

  const body = (
    <div style={modalStyle} className={classes.paper}>
      <h2 id="simple-modal-title" className={classes.heading}>ENTER EVENT CODE</h2>
      <p id="simple-modal-description" className={classes.text}>
        Enter the event code sent via email when you purchased your Livestream ticket. 
      </p>
      <form noValidate autoComplete="off" onSubmit={handleSubmit}>
              <TextField
                id="email"
                label="Email"
                onChange={e => setEmail(e.target.value.trim().toLowerCase())}
                variant="outlined"
                fullWidth
                value={email}
                className={classes.inputField}
                autocomplete="new-password"
                InputProps={{
                  className: classes.input,
                    autocomplete:"new-password"
                }}
                style={{border: '1px solid rgba(145, 158, 171, 0.32)', margin: '24px 0 0'}}
              />
              <TextField
                id="eventCode"
                label="Event Code"
                type="text"
                onChange={e => setEventCode(e.target.value)}
                variant="outlined"
                autocomplete="new-password"
                value={code}
                fullWidth
                className={classes.inputField}
                InputProps={{
                  className: classes.input,
                }}
                style={{border: '1px solid rgba(145, 158, 171, 0.32)', margin: '24px 0 0'}}
              />

              <Grid container>
                <Grid item xs={12} className={classes.msgGrid}>
                  { formMsg && formMsg.length > 0 &&
                    <h5 className={classes.msg}>{formMsg}</h5>
                  }
                </Grid>
              </Grid>    

              <Grid container className={classes.submit}>
                  <Grid md={8} xs={12}>
                    {
                        sessionData && sessionData.ticketUrl &&<Typography component='div' className={classes.helpText}><Typography component="span" style={{opacity: '0.7', display: 'inline-block', marginRight: '10px'}}>To purchase a ticket click here: </Typography>
                       <Link to={{pathname: sessionData.ticketUrl}} target="_blank"   style={{color: '#76A5FB'}}>Get tickets</Link>
                      </Typography>}
                  </Grid>
                  <Grid md={4} xs={12}>
                  <Button type="button" variant="contained" color="primary" disableElevation disabled={''} onClick={handleClose}
                  className={classes.cancel} style={{marginRight: '11px'}}>
                    Cancel
                  </Button>
                  <Button type="submit" variant="contained" color="primary"
                  className={classes.enter}>
                    Enter
                  </Button>
                  </Grid>
              </Grid>
            </form>
      {/* <SimpleModal /> */}
    </div>
  );

  return (
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {body}
      </Modal>
  );
}
